import React, { FC } from "react";
import { Tab as SemanticTab, TabProps } from "semantic-ui-react";
import styles from "./styles.module.scss";

export const Tab: FC<TabProps> = (props) => {
  return <SemanticTab className={styles.tab} {...props} />;
};
